import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const Layout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_enseres-cadiz/artifacts/gxff3hzr_VALORIZA_color_positivo.png" 
              alt="Valoriza" 
              className="h-10"
            />
            <div>
              <h1 className="text-lg font-bold text-gray-900">Valoriza Cádiz</h1>
              <p className="text-xs text-gray-500">Recogida de Enseres</p>
            </div>
          </Link>
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/solicitud" className="text-sm font-medium text-gray-700 hover:text-primary transition">
              Nueva Solicitud
            </Link>
            <Link to="/consulta" className="text-sm font-medium text-gray-700 hover:text-primary transition">
              Consultar Estado
            </Link>
            <Link to="/admin/login" className="text-sm font-medium text-gray-500 hover:text-gray-700 transition">
              Acceso Administrativo
            </Link>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-bold text-lg mb-4">Valoriza Cádiz</h3>
              <p className="text-sm text-gray-400">
                Sistema de gestión de recogida de enseres y muebles para el municipio de Cádiz.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Enlaces</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/solicitud" className="hover:text-white">Nueva Solicitud</Link></li>
                <li><Link to="/consulta" className="hover:text-white">Consultar Estado</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contacto</h4>
              <p className="text-sm text-gray-400">
                Para consultas o incidencias, contáctenos a través de los canales oficiales del Ayuntamiento de Cádiz.
              </p>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
            <p>© {new Date().getFullYear()} Valoriza Cádiz. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;